export default {
  notFound: "The page you requested could not be found.",
  aboutUs: "About Us",
  blog: "Blog",
  // button actions
  actions: "Actions",
  submit: "Submit",
  search: "Search",
  create: "Create",
  save: "Save",
  saveChanges: "Save Changes",
  cancel: "Cancel",
  ok: "OK",
  goBack: "Go Back",
  go: "Go",
  confirm: "Confirm",
  unavailable: "Unavailable",
  edit: "Edit",
  editDetails: "Edit Details",
  configure: "Configure",
  add: "Add",
  downloadPdf: "Download PDF",
  view: "View",
  delete: "Delete",
  continue: "Continue",
  homePage: "Home Page",
  // alerts/confirmations
  areYouSure: "Are you sure?",
  // general notifications
  success: "Success",
  warning: "Warning",
  error: "Error",
  saveSuccess: "Successfully saved.",
  saveFailure: "Failed to save.",
  somethingWentWrong: "Something went wrong, please try again later.",
  // statuses
  status: "Status",
  configured: "Configured",
  notConfigured: "Not Configured",
  connected: "Connected",
  notConnected: "Not Connected",
  yes: "Yes",
  no: "No",
  on: "On",
  off: "Off",
  lastModified: "Last Modified",
  // auth
  fullName: "Full Name",
  emailAddress: "Email Address",
  password: "Password",
  existingPassword: "Existing Password",
  passwordPlaceholder: "Enter password",
  confirmPassword: "Confirm Password",
  login: "Login",
  createAccount: "Create Account",
  forgetPassword: "Forget your password?",
  register: "Register",
  beClassical: "or be classical",
  agreeToThe: "I agree to the",
  termsAndConditions: "terms and conditions",
  getStarted: "Get Started",
  invoiceSettings: "Invoice Settings",
  invoicingDescription:
    "Send professional invoices, set recurring invoices. accept online payments instantly.",
  expenses: "Expenses",
  expensesDescription:
    "Record and store your expenses, keep receipts assign to customers, identify your profitability.",
  freeSupport: "Free Support",
  freeSupportDescription:
    "Got a problem? your problem is our problem! our customer team is always ready to help.",
  emailVerification: "Email Verification",
  pleaseVerifyYourEmailAddress:
    "We have sent you an email with steps to follow to verify your email address.",
  emailVerified: "Your email address has been verified.",
  resendVerificationEmail: "Resend Verification Email",
  sendVerificationEmailSuccess: "We've sent you a verification email.",
  sendVerificationEmailFailure:
    "We tried to send you a verification email but something went wrong.",
  resetPassword: "Reset Password",
  resetPasswordDetails: "Please provide your email address.",
  resetPasswordFormDetails:
    "Please fill out the form below in order to reset your password.",
  resetPasswordEmailSent:
    "We have sent you an email with the steps to reset your password.",
  sendPasswordResetEmailFailure:
    "We tried to send you a password reset email but something went wrong.",
  passwordResetSuccess: "Your password has been reset.",
  passwordResetFailure:
    "There was an issue resetting your password at this time. Please try again later or contact Smartbooks Support.",
  newPassword: "New Password",
  comingSoon: "Coming Soon",
  goToSmartbooks: "Go to Smartbooks",
  // Documents
  document: "Document",
  number: "Number",
  issuedDate: "Issued Date",
  dueDate: "Due Date",
  from: "From",
  to: "To",
  noCustomerSelected: "No customer selected",
  addItem: "Add Item",
  subTotal: "Sub Total",
  vatTotal: "VAT Total",
  total: "Total",
  terms: "Terms",
  termsPlaceholder: "Place terms here...",
  noTerms: "No terms",
  notes: "Notes (not on issued document)",
  notesPlaceholder: "Place notes here...",
  noNotes: "No notes",
  createPdfFailure:
    "We failed to create your PDF at this time. Please try again later or contact Smartbooks Support.",
  details: "Details",
  // Dashboard
  date: "Date",
  time: "Time",
  description: "Description",
  totalInvoiced: "Total Invoiced",
  totalPaid: "Total Paid",
  outstandingBalance: "Outstanding Balance",
  itemsSold: "Items Sold",
  invoiced: "Invoiced",
  paid: "Paid",
  last30Days: "Last 30 Days",
  // Invoices
  invoices: "Invoices",
  noInvoices: "You haven't issued any Invoices.",
  addFirstInvoice: " Issue an Invoice",
  invoiceHistory: "Invoice History",
  newInvoice: "New Invoice",
  invoiceDetails: "Invoice Details",
  invoiceLogo: "Logo",
  invoiceHeader: "Header",
  dateSent: "Issued Date",
  dateDue: "Due Date",
  chooseDate: "Choose a date",
  invoice: "Invoice",
  invoiceNumber: "Invoice Number",
  invoiceReference: "Invoice Reference",
  invoiceFrom: "From",
  invoiceSender: "Sender",
  invoiceTo: "Billed To",
  invoiceRecipient: "Invoice To",
  invoiceBillingTo: "Billing To",
  invoicePleaseSelectCustomer: "Please select a customer",
  invoiceToName: "Name",
  invoiceToEmailAddress: "Email",
  invoiceCustomerPlaceholder: "Select customer",
  invoiceSubTotal: " Sub Total",
  invoiceVatTotal: "VAT Total",
  invoiceTotal: "Total",
  invoiceStatus: "Status",
  invoiceStatusIssued: "Issued",
  invoiceStatusClosed: "Closed",
  invoiceItems: "Items",
  invoiceItem: "Description",
  invoiceAddItem: "Add Item",
  invoiceItemDescription: "Description",
  invoiceItemUnitCost: "Price",
  invoiceItemQuantity: "Qty",
  invoiceItemVat: "VAT (%)",
  invoiceItemPrice: "Total",
  invoiceValue: "Value",
  invoiceTermsAndNotes: "Terms & Notes",
  invoiceTerms: "Terms",
  invoiceTermsPlaceholder: "Put any invoice terms here...",
  invoiceNotes: "Notes (not displayed on invoice)",
  invoiceNotesPlaceholder: "Put any additional notes here...",
  invoiceActions: "Actions",
  invoicePaymentInformation: "Payment Information",
  invoiceTypeOnceOff: "Once-off",
  invoiceTypeRecurring: "Recurringly",
  invoiceSetStatusToPaid: "Mark as Paid",
  invoiceSetStatusToPaidConfirmationText:
    "You will no longer be able to receive online payment for this invoice once it is marked as Paid.",
  invoiceSetStatusToPaidSuccess: "Successfully marked invoice as Paid.",
  invoiceSetStatusToPaidFailure:
    "We failed to mark your invoice as Paid at this time, please try again later or contact Smartbooks Support.",
  submitInvoiceSuccess: "Successfully submitted invoice.",
  submitInvoiceFailure: "Failed to submit invoice.",
  invalidInvoice: "Invalid invoice, please check all fields.",
  defaultVatRate: "Default VAT Rate",
  defaultVatRatePlaceholder: "E.g. 23",
  defaultPaymentPeriod: "Default Payment Period",
  defaultPaymentPeriodPlaceholder: "E.g. 30 days",
  days: "days",
  viewInvoice: "View Invoice",
  viewInvoiceFailure:
    "We failed to load this Invoice at this time. Please try again later or contact Smartbooks Support.",
  invoiceAlreadyCreditedConfirmationText:
    "This Invoice has already been credited.",
  invoiceRefunds: "Refunds",
  removeItem: "Remove Item",
  // Recurring invoices
  recurringInvoice: "Recurring Invoice",
  recurringInvoices: "Recurring Invoices",
  noRecurringInvoices: "You haven't scheduled any Recurring Invoices.",
  addFirstRecurringInvoice: "Schedule a Recurring Invoice",
  recurringInvoiceDetails: "Recurring Invoice Details",
  newRecurringInvoice: "New Recurring Invoice",
  cancelRecurringInvoice: "Terminate",
  cancelRecurringInvoiceMessage:
    "Once cancelled, invoices will stop being issued!",
  cancelRecurringInvoiceSuccess: "Recurring Invoice successfully terminated.",
  cancelRecurringInvoiceFailure:
    "We failed to terminate your Recurring Invoice at this time, please try again later or contact Smartbooks Support.",
  recurringInvoiceWillBeIssued: "Will be issued",
  recurringInvoiceRepeatEvery: "Repeat every",
  recurringInvoiceDay: "Day",
  recurringInvoiceWeek: "Week",
  recurringInvoiceMonth: "Month",
  recurringInvoiceYear: "Year",
  recurringInvoiceDaily: "Daily",
  recurringInvoiceWeekly: "Weekly",
  recurringInvoiceMonthly: "Monthly",
  recurringInvoiceYearly: "Yearly",
  recurringInvoiceStatus: "Status",
  recurringInvoiceEndTypeNever: "Never",
  recurringInvoiceEndTypeOnDate: "On specific date",
  recurringInvoiceEndTypeAfterOccurrences: "After number of issues",
  recurringInvoicePickADay: "Pick a day",
  recurringInvoiceMore: "More",
  recurringInvoiceAfter: "After",
  recurringInvoiceOccurrences: "Issues",
  recurringInvoiceStatusActive: "Active",
  recurringInvoiceStatusComplete: "Complete",
  recurringInvoiceStatusCancelled: "Cancelled",
  recurringInvoiceBillingTo: "Billing To",
  recurringInvoicePeriod: "Period",
  recurringInvoiceNextIssue: "Next Issue",
  recurringInvoiceEnding: "Ends",
  recurringInvoiceTimeToPay: "Days to pay",
  recurringInvoicePaymentDays: "days",
  recurringInvoiceFirstIssue: "First Issue",
  submitRecurringInvoiceSuccess: "Recurring invoice saved.",
  submitRecurringInvoiceFailure: "Failed to submit recurring invoice.",
  viewRecurringInvoice: "View Recurring Invoice",
  viewRecurringInvoiceFailure:
    "We failed to load this Recurring Invoice at this time. Please try again later or contact Smartbooks Support.",
  invoicesIssued: "Invoices Issued",
  nextInvoiceDate: "Next Invoice",
  // Credit Notes
  creditNotes: "Credit Notes",
  noCreditNotes: "You haven't issued any Credit Notes.",
  creditNote: "Credit Note",
  creditNoteDetails: "Credit Note Details",
  creditNoteHistory: "Credit Note History",
  creditNoteNumber: "Credit Note Number",
  creditNoteCorrespondingInvoice: "Corresponding Invoice",
  creditNoteTotal: "Total",
  creditNoteCreditedTo: "Credited To",
  creditNoteReason: "Reason",
  creditNoteReasonPlaceholder: "Select a Reason",
  issueOnlineRefund: "Issue Online Refund",
  onlineRefundIssued: "Online Refund Issued",
  issueOnlineRefundDescription:
    "A refund will be made directly to the Customer via Stripe.",
  onlineRefundAlreadyProcessedDescription:
    "An online refund has already been processed for this Invoice.",
  generateCreditNote: "Generate Credit Note",
  generateCreditNoteFailure:
    "We failed to generate a Credit Note for that Invoice at this time. Please try again later or contact Smartbooks Support",
  submitCreditNoteSuccess: "Successfully submitted Credit Note.",
  submitCreditNoteFailure:
    "Failed to submit Credit Note. Please try again later or contact Smartbooks Support.",
  // Account
  account: "Account",
  yourAccount: "Your Account",
  // Account > Profile
  profile: "Profile",
  userName: "Name",
  userNamePlaceholder: "Your full name",
  userEmailAddress: "Email",
  userEmailAddressPlaceholder: "Your email address",
  editProfileButton: "Edit Profile",
  changePassword: "Change Password",
  // Account > Subscription
  subscription: "Subscription",
  subscriptionPlan: "Plan",
  subscriptionFreeTrial: "Free Trial",
  subscriptionEndDate: "Ending",
  subscriptionNextBill: "Next Bill",
  subscriptionCancelled: "Cancelled",
  subscriptionExpired: "Subscription Expired",
  goPremiumButton: "Go Premium",
  changePlanButton: "Change Plan",
  currentPlan: "Current Plan",
  reactivate: "Reactivate",
  beta: "Beta",
  month: "month",
  goEssential: "Go Essential",
  cancelSubscription: "Cancel Subscription",
  cancelSubscriptionConfirmationText:
    "You will no longer have access to the <PLAN> Plan features once cancelled.",
  cancelSubscriptionSuccess: "Subscription cancelled.",
  cancelSubscriptionFailure:
    "We failed to cancel your subscription at this time, please try again later or contact our support team.",
  changeSubscriptionConfirmationHTML:
    "<p>Your subscription will be changed to the <strong>{{plan}}</strong> plan with a new monthly bill of <strong>{{price}}</strong>.</p>",
  changeSubscriptionCreditAddedToAccountHTML:
    "<p>Please note that an outstanding subscription credit of <strong>{{amount}}</strong> will be offset against future subscription charges.</p>",
  changeSubscriptionCostAddedToNextBillHTML:
    "<p>Please note that we are not going to bill you right now for upgrading. An additional charge of <strong>{{amount}}</strong> will be added to your next bill.</p>",
  changeSubscriptionNextBillMayChangeHTML:
    "<p>This may change if your subscription is updated.</p>",
  reactivateSubscriptionConfirmationHTML:
    "<p>Your subscription to the <strong>{{plan}}</strong> plan will resume with a monthly bill of <strong>{{price}}</strong>.</p>",
  changeSubscriptionSuccess: "Subscription changed.",
  changeSubscriptionFailure:
    "We failed to change your subscription at this time, please try again later or contact our support team.",
  reactivateSubscriptionSuccess: "Subscription reactivated.",
  reactivateSubscriptionFailure:
    "We failed to reactivate your subscription at this time, please try again later or contact our support team.",
  cantChangeSubscriptionWarning:
    "Please note that you will not be able to subscribe to a different plan until after your current subscription has expired on $DATE. If you wish to subscribe to a different plan, you must first reactivate your existing subscription.",
  changeCardDetails: "Change Card Details",
  changeCardDetailsSuccess: "Successfully updated Card Details.",
  changeCardDetailsFailure:
    "We failed to update your Card Details at this time, please try again later or contact Smartbooks Support.",
  // Account > Advanced
  advanced: "Advanced",
  personalDetails: "Personal Details",
  resetSettings: "Reset Settings",
  resetSettingsInfo:
    "All settings will be reset to the Smartbooks default values.",
  closeAccount: "Close Account",
  closeAccountInfo: "Your account and data will be permanently deleted.",
  logout: "Sign out",
  // Customers
  customers: "Customers",
  customer: "Customer",
  newCustomer: "New Customer",
  companyLogo: "Logo",
  companyDetails: "Company Details",
  companyName: "Business Name",
  companyNamePlaceholder: "Business Name",
  companyEmailAddress: "Email",
  companyEmailAddressPlaceholder: "Company email address",
  companyVatNumber: "VAT No.",
  companyVatNumberPlaceholder: "VAT no",
  address: "Address",
  addresses: "Addresses",
  noAddressesConfiguredWarning: "Address not configured.",
  companyAddress: "Business Address",
  addressLine1: "Line 1",
  addressLine1Placeholder: "Line 1",
  addressLine2: "Line 2",
  addressLine2Placeholder: "Line 2",
  addressDistrict: "District / Town",
  addressDistrictPlaceholder: "District / Town",
  addressRegion: "State / County",
  addressRegionPlaceholder: "State / County",
  addressCountry: "Country",
  addressCountryPlaceholder: "Country",
  addressPostcode: "Postcode",
  addressPostcodePlaceholder: "Postcode",
  contactDetails: "Contact Details",
  contactName: "Contact Name",
  contactNamePlaceholder: "Contact name",
  contactNumber: "Contact No.",
  contactNumberPlaceholder: "Contact no",
  customerNotes: "Notes",
  customerNotesPlaceholder: "You can enter notes here...",
  submitCustomerSuccess: "Customer saved.",
  submitCustomerFailure: "Failed to save customer.",
  editCustomer: "Edit Customer",
  deleteCustomer: "Delete Customer",
  deleteCustomerConfirmationText:
    "You will not be able to recover this customer once deleted.",
  deleteCustomerSuccess: "Customer deleted.",
  deleteCustomerFailure: "Failed to delete customer.",
  loadCustomerFailure:
    "There was an issue loading this Customer at this time. Please try again later or contact Smartbooks Support.",
  customerStatementDescription:
    "Monthly Statements will be issued to the customer, providing an overview of their outstanding Invoices and Credit Notes",
  customerStatementsDisabledWarning:
    "Customer Statements are currently disabled in your Statements Settings.",
  customerPaymentRemindersDescription:
    "Payment Reminders will be issued to the customer when Invoices become overdue. We will issue a reminder 1 day after an Invoice is overdue, followed by an additional reminder every 7 days.",
  paymentRemindersDisabledWarning:
    "Payment Reminders are currently disabled in your Payments Settings.",
  // Settings
  saveSettingsSuccess: "Settings saved.",
  saveSettingsFailure:
    "We failed to save your settings at this time, please try again later or contact Smartbooks Support",
  // Settings > BusinessDetails
  businessDetails: "Business Details",
  logo: "Logo",
  name: "Name",
  // Settings > Accounting
  defaultInvoiceValues: "Default Invoice Values",
  payments: "Payments",
  paymentSettings: "Payment Settings",
  // Settings > Payments > Bank Details
  bankDetails: "Bank Details",
  bankDetailsDescription:
    "If provided, your Bank Details will be displayed on all of your Invoices.",
  noBankDetailsConfiguredWarning: "Bank details not configured.",
  bankName: "Bank Name",
  bankNamePlaceholder: "Bank name (must match exactly)",
  bankAccountName: "Account Name",
  bankAccountNamePlaceholder: "Account name (must match exactly)",
  bankAccountNumber: "Account Number",
  bankAccountNumberPlaceholder: "Account number",
  bankAccountSortCode: "Sort Code",
  bankAccountSortCodePlaceholder: "Sort code",
  bankAccountBic: "BIC",
  bankAccountBicPlaceholder: "Bank Identifier Code",
  bankAccountIban: "IBAN",
  bankAccountIbanPlaceholder: "International Bank Account Number",
  bankPaymentReference: "Payment Reference",
  updateBankDetailsSuccess: "Bank Details successfully updated.",
  updateBankDetailsFailure:
    "We failed to update your Bank Details at this time. Please try again later or contact Smartbooks Support.",
  // Settings > Payments > Online Payments
  onlinePayments: "Online Payments",
  onlinePaymentFee: "Online Payment Fee",
  onlinePaymentFeeInfo:
    "The customer will pay this fee in addition to the price of the service they are booking.",
  stripe: "Stripe",
  connectStripeAccount: "Connect with Stripe",
  connectStripeAccountDescription:
    "We will redirect you to Stripe where you can create a new account or connect an existing one.",
  connectWithStripeFailure:
    "We failed to connect your Smartbooks account with Stripe at this time, please try again later or contact Smartbooks Support",
  stripeConnected: "Stripe Connected, You are able to receive Online Payments.",
  paymentDetails: "Payment Details",
  paymentSuccessfullyPaidTo: "successfully paid to",
  paymentFailed:
    "There was an issue processing your payment at this time, please try again later or contact",
  disconnectStripe: "Disconnect Stripe",
  disconnectStripeDescription:
    "Your Stripe account will be disconnected, allowing you to reconnect with a different Stripe account",
  disconnectStripeConfirmationText:
    "You will no longer be able to receive online payments once your Stripe account has been disconnected",
  disconnectStripeSuccess: "Stripe account successfully disconnected",
  disconnectStripeFailure:
    "There was an issue disconnecting your Stripe account at this time, please try again later or contact Smartbooks Support",
  // Settings > Payments > Payment Reminders
  paymentReminders: "Payment Reminders",
  paymentRemindersDescription:
    "Payment Reminders are issued to your Customers when Invoices become overdue. We will issue a reminder 1 day after an Invoice is overdue, followed by an additional reminder every 7 days.",
  paymentRemindersEnabled: "Payments Reminders are now enabled.",
  paymentRemindersDisabled: "Payment Reminders are now disabled.",
  // Settings > Statements
  statements: "Statements",
  customerStatements: "Customer Statements",
  customerStatementsDescription:
    "Your Customers will receive monthly Statements, providing an overview of their outstanding Invoices and Credit Notes.",
  customerStatementsEnabled: "Customer Statements are now enabled.",
  customerStatementsDisabled: "Customer Statements are now disabled.",
  updateCustomerStatementsFailure:
    "We failed to update your Customer Statements configuration at this time. Please try again later or contact Smartbooks Support",
  // bookings
  bookAgainButton: "Book Again",
  bookings: "Bookings",
  bookingsV2: "Bookings v2 (Beta)",
  addBooking: "Add Booking",
  searchBookings: "Search Bookings",
  confirmBooking: "Confirm Booking",
  bookingServicePlaceholder: "Select a Service",
  bookingPackagePlaceholder: "Select a Package",
  bookingDetails: "Booking Details",
  bookingDatePlaceholder: "Date",
  bookingStartTimePlaceholder: "Start time",
  bookingEndTimePlaceholder: "End time",
  bookingCustomerDetails: "Customer Details",
  bookingCustomerNamePlaceholder: "Full name",
  bookingCustomerPhoneNumberPlaceholder: "+353 87 123 4567",
  bookingCustomerEmailPlaceholder: "joeblogs@example.com",
  bookingNotes: "Notes",
  bookingNotesPlaceholder: "Enter notes here...",
  bookingPaymentStatusTypes: {
    NOT_PAID: "Not Paid",
    PAID: "Paid"
  },
  // management
  management: "Management",
  // resources
  resources: "Resources",
  noResources: "You haven't added any Resources.",
  addAResource: "Add a Resource",
  addResource: "Add Resource",
  editResource: "Edit Resource",
  resourceName: "Name",
  resourceNamePlaceholder: "Enter a name",
  resourceEnabled: "Enabled",
  resourceUnits: "Units",
  resourceUnitsPlaceholder: "Enter the number of units that you have",
  resourceAvailableForOnlineBookings: "Available for Online Bookings",
  resourceOnlineBookings: "Online Bookings",
  resourceRosterLunchEndLabel: "End Lunch",
  resourceRosterLunchStartLabel: "Start Lunch",
  resourceRosterWorkEndLabel: "End Work",
  resourceRosterWorkStartLabel: "Start Work",
  resourceSaved: "Resource saved",
  resourceDeleted: "Resource deleted",
  // services
  services: "Services",
  service: "Service",
  noServices: "You haven't added any Services.",
  addFirstService: "Add a Service",
  addService: "Add Service",
  editService: "Edit Service",
  serviceDetails: "Service Details",
  serviceName: "Name",
  serviceNamePlaceholder: "Enter a name",
  serviceDescription: "Description",
  serviceDescriptionPlaceholder: "Enter a description",
  serviceType: "Type",
  serviceOnlyBookable: "Book Service Only",
  serviceEmployeeBookable: "Book by Employee",
  serviceResourceBookable: "Book by Resource",
  serviceEnabled: "Enabled",
  serviceAvailableForOnlineBookings: "Available online",
  serviceRequireContact: "Require contact",
  serviceRequireContactByEmail: "by email",
  serviceRequireContactByPhone: "by phone",
  serviceSaved: "Service saved",
  serviceHideDurations: "Hide durations",
  // packages
  packages: "Packages",
  package: "Package",
  basePackage: "Base Package",
  extraPackage: "Extra Package {number}",
  packageName: "Name",
  packageNamePlaceholder: "Enter a name",
  packagePrice: "Price",
  packagePricePlaceholder: "Enter a price",
  packageDuration: "Service length",
  packageDisplayDuration: "Booking Intervals",
  minutes: "Minutes",
  hours: "Hours",
  packageDurationPlaceholder: "Enter a duration",
  serviceDisplayDuration: "Enter a display duration",
  packageDescription: "Description",
  packageDescriptionPlaceholder: "Enter a description (optional)",
  addPackage: "Add Package",
  // employees
  employees: "Employees",
  employee: "Employee",
  employeeName: "Name",
  employeeNamePlaceholder: "Enter a name",
  employeeDescription: "Description",
  employeeDescriptionPlaceholder: "Optionally enter a description",
  employeeTipUrl: "Link for receiving tips",
  employeeAvailableForOnlineBookings: "Available for Online Bookings",
  employeeOnlineBookings: "Online Bookings",
  employeeRosterOnlineWithoutDays:
    "Online bookings are on, but no work days are ticked.",
  employeeRosterHeading: "Usual days and hours",
  employeeRosterUsualHoursHint:
    "The hours they normally work.",
  employeeRosterDefaultsHint:
    "Starts as the shop’s open days.",
  noEmployees: "You haven't added any Employees.",
  addAnEmployee: "Add an Employee",
  addEmployee: "Add Employee",
  editEmployee: "Edit Employee",
  employeeSaved: "Employee saved",
  deleteEmployeeWarning: "This Employee will be permanently deleted",
  employeeDeleteTitle: "Delete {name}?",
  employeeDeleteLead: "This cannot be undone.",
  employeeDeleteRosterIntro: "This also removes their roster:",
  employeeDeleteNoRoster: "They have no roster days to remove.",
  employeeDeleteBookingsStay: "Bookings are not removed.",
  employeeDeleteConfirm: "Delete",
  employeeDeleteBlockedTitle: "Can't delete {name}",
  employeeDeleteBlockedOne:
    "They still have a confirmed booking. It is {when}.",
  employeeDeleteBlockedMany:
    "They still have {count} confirmed bookings. The last is {when}.",
  employeeDeleted: "Employee deleted",
  choosePicture: "Choose a photo — large files are resized automatically",
  choosePictureFailure: "Failed to process image. Try a JPG or PNG under 12MB.",
  avatarFor: "Avatar for {name}",
  selectAnEmployee: "Select an Employee",
  // roster
  roster: "Roster",
  rosterV2: "Roster v2 (Beta)",
  rosterCalendar: "Roster Calendar",
  rosterScheduleEvent: "Schedule Event",
  rosterEvent: "Event",
  rosterEventFrom: "From",
  rosterEventTo: "To",
  rosterEmployeeWorkHours: "Work Hours",
  rosterEmployeeBreak: "Break",
  rosterEmployeeHoliday: "Holiday",
  rosterEmployeeSick: "Sick",
  rosterSettingsTitle: "Rostering",
  rosterSettingsRollingPeriodLabel: "Rolling Period",
  rosterSettingsRollingPeriodPreview: "{days} days",
  rosterSettingsDescription:
    "Roster employees for the next <strong>{rosterRollingPeriodDays} days</strong>. New Roster created each <strong>{rosterRollingDay}</strong>.",
  // shops
  shopfront: "Shopfront",
  shopfrontDetails: "Shopfront Details",
  OnlyAny: "Only Allow Any",
  AnyOff: "Off",
  AnyOn: "On"
};
